<template>
  <div class="look-detail">
    <div class="nav">
      <div class="nav-left">
        <div class="parallelogram-btn-left" @click="toMildew" :class="{'parallelogram-btn-active': lossType === 1}" style="margin-right: 0.5vw">
          <div>自然损耗</div>
        </div>
        <div class="parallelogram-btn-left" @click="toNatural" :class="{'parallelogram-btn-active': lossType === 2}" style="margin-right: 0.5vw">
          <div>霉变损耗</div>
        </div>
        <div class="parallelogram-btn-left" @click="toCrushed" :class="{'parallelogram-btn-active': lossType === 3}">
          <div>造碎损耗</div>
        </div>
      </div>
      <div class="nav-center"><div>{{title}}</div></div>
      <div class="nav-right">
        <div class="parallelogram-btn-right" @click="toPests" :class="{'parallelogram-btn-active': lossType === 4}" style="margin-right: 0.5vw">
          <div>虫害损耗</div>
        </div>
        <div class="parallelogram-btn-right" @click="tCarbide" :class="{'parallelogram-btn-active': lossType === 5}" style="margin-right: 0.5vw">
          <div>碳化损耗</div>
        </div>
        <div class="parallelogram-btn-right" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="loss-main" v-if="hide">
        <div class="loss-main-select">
          <div class="input-date-wrapper">
            <el-date-picker
              v-model="value"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="input-wrapper">
            <input v-model="keyword" placeholder="请输入批次号或烟叶简称"/>
          </div>
          <div class="query button" @click="handleSearch(1)">查询</div>
        </div>
        <div class="loss-main-operation">
          <div class="loss-main-operation-l">
            <div class="two-font-wrapper" style="margin-right: 1vw" @click="toLookDetailNew"><div class="icon-font">&#xe605;</div>添加</div>
            <div class="four-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
          </div>
          <div class="loss-main-operation-r">损耗统计：{{lossWeightStatistical || 0}}g</div>
        </div>
        <div class="detail">
          <div class="detail-box">
            <div class="loading-data" v-if="loading">
              <i class="el-icon-loading"></i>
              <div>加载中，请稍后···</div>
            </div>
            <div class="detail-nav">
              <div class="detail-item" style="width: 5%">
                <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
              </div>
              <div class="detail-item" style="width: 5%">序号</div>
              <div class="detail-item" style="width: 10%">批次号</div>
              <div class="detail-item" style="width: 20%">烟叶简称</div>
              <div class="detail-item" style="width: 15%">仓库位置</div>
              <div class="detail-item" style="width: 10%">日期</div>
              <div class="detail-item" style="width: 10%">损耗重量(g)</div>
              <div class="detail-item" style="width: 10%">损耗原因</div>
              <div class="detail-item" style="width: 10%">备注</div>
              <div class="detail-item" style="width: 10%">操作</div>
            </div>
            <div class="detail-content">
              <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
                <div class="detail-item" style="width: 5%">
                  <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
                </div>
                <div class="detail-item" style="width: 5%">{{index+1}}</div>
                <div class="detail-item" style="width: 10%">{{data.batch}}</div>
                <div class="detail-item" style="width: 20%">{{data.materialName}}</div>
                <div class="detail-item" style="width: 15%">{{data.siteName}}</div>
                <div class="detail-item" style="width: 10%">{{data.createdTime}}</div>
                <div class="detail-item" style="width: 10%">{{data.lossWeight}}</div>
                <div class="detail-item" style="width: 10%">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="data.lossReson">
                    <div class="popover" style="width: 6vw;text-align: center" slot="reference">{{data.lossReson}}</div>
                  </el-popover>
                </div>
                <div class="detail-item" style="width: 10%">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="data.remark">
                    <div class="popover" style="width: 6vw;text-align: center" slot="reference">{{data.remark}}</div>
                  </el-popover>
                </div>
                <div class="detail-item" style="width: 10%">
                  <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="toLookDetailView(data)">查看</div>
                  <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
                </div>
              </div>
              <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
            </div>
            <div class="page-wrapper" v-if="!loading && total > rows">
              <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
              <div class="page-wrapper-right">
                <div class="page-btn" @click="firstPage">首页</div>
                <div class="page-btn" @click="previousPage">上一页</div>
                <div class="page-btn" @click="nextPage">下一页</div>
                <div class="page-btn" @click="lastPage">尾页</div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="show">
              <div class="alert-content">
                <div class="alert-content-title">删除提醒</div>
                <div class="alert-content-msg">是否确认删除选中数据?</div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelDelete">取消</div>
                  <div class="btn-confirm button" @click="confirmDelete">确认</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {queryPageList, bathDelPageList, delPageList} from '../../../api/maintain'
import localforage from 'localforage'
export default {
  name: 'LookDetail',
  data () {
    return {
      loading: true,
      title: '',
      hide: false,
      value: '',
      show: false,
      all: false,
      id: '',
      type: 0,
      lossType: '',
      idList: [],
      lossWeightStatistical: '',
      beginTime: '',
      endTime: '',
      keyword: '',
      page: 1,
      rows: 7,
      tableData: []
    }
  },
  created () {
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    let lossType = parseInt(this.$route.query.lossType)
    console.log(lossType)
    _this.lossType = lossType
    this.getTitle(lossType)
    _this.handleSearch(1)
  },
  watch: {
    '$route' () {
      this.getTitle(this.$route.query.lossType)
      this.handleSearch(1)
    },
    value: function () {
      this.beginTime = this.value !== null ? this.value[0] : ''
      this.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  methods: {
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1
      }
      this.loading = true
      let body = {
        beginTime: this.beginTime,
        endTime: this.endTime,
        lossType: this.lossType,
        keyword: this.keyword,
        page: this.page,
        rows: this.rows
      }
      queryPageList(body).then(res => {
        console.log(res)
        this.lossWeightStatistical = res.data.lossWeightStatistical
        res.data.page.rows && res.data.page.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.page.rows || []
        this.total = res.data.page.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id)
        let body = {
          id: this.id
        }
        delPageList(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        console.log(this.idList)
        let body = {
          idArray: this.idList
        }
        bathDelPageList(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    getTitle: function (lossType) {
      switch (lossType) {
        case 1:
          this.title = '自然损耗'
          break
        case 2:
          this.title = '霉变损耗'
          break
        case 3:
          this.title = '造碎损耗'
          break
        case 4:
          this.title = '虫害损耗'
          break
        case 5:
          this.title = '碳化损耗'
          break
      }
    },
    backPath: function () {
      this.$router.push({
        path: '/loss',
        query: {
          index: '9',
          lossType: this.lossType
        }
      })
    },
    toLookDetailView: function (data) {
      let _this = this
      localforage.setItem('lossInfo', data).then(res => {
        _this.$router.push({
          path: '/loss/lookDetailView',
          query: {
            index: '9'
          }
        })
      })
    },
    toLookDetailNew: function () {
      this.$router.push({
        path: '/loss/lookDetailNew',
        query: {
          index: '9'
        }
      })
    },
    toMildew: function () {
      this.lossType = 1
      this.goPath(this.lossType)
    },
    toNatural: function () {
      this.lossType = 2
      this.goPath(this.lossType)
    },
    toCrushed: function () {
      this.lossType = 3
      this.goPath(this.lossType)
    },
    toPests: function () {
      this.lossType = 4
      this.goPath(this.lossType)
    },
    tCarbide: function () {
      this.lossType = 5
      this.goPath(this.lossType)
    },
    goPath: function (lossType) {
      this.$router.push({
        path: '/loss/lookDetail',
        query: {
          index: '9',
          lossType: lossType
        }
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "Loss.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/loss/LookDetail.vue